// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__-CVTA","breadcrumbs__link":"Breadcrumbs_breadcrumbs__link__iySUE","breadcrumbs__img":"Breadcrumbs_breadcrumbs__img__RODp3"};